import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { CadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/cadenas.service';
//import { CatalogoCadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/catalogo-cadenas.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosVModel, IndicadoresVivosVModelInterface } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { DireccionesService } from '../../services/direcciones.service';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { VersionesService } from '../../services/versiones.service';

@Component({
  selector: 'app-registro-de-versiones',
  templateUrl: './registro-de-versiones.component.html',
  styleUrls: ['./registro-de-versiones.component.css']
})
export class RegistroDeVersionesComponent implements OnInit {

  tituloCard: string = 'Registro de Versiones';
  tituloForm: string = 'Lista De Versiones';

  formulario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstados: any[] = [
    {
      clave: 'A',
      valor: 'ACTIVO'
    },
    {
      clave: 'C',
      valor: 'CERRADO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _versiones: VersionesService
  ) { }

  ngOnInit() {
    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      id: ['', null],
      anio: ['', [Validators.required, , Validators.maxLength(4), Validators.min(new Date().getFullYear())]],
      nombre: ['', [Validators.required, Validators.maxLength(30)]],
      version: ['', [Validators.required, Validators.maxLength(3)]],
      estado: ['', null],
      estadoDesc: ['', null],
    });

    this.cargarGridcomponent();
    this.getVersiones();

  }

  /* FUNCIONES */
  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'id',
        filter: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Año',
        field: 'anio',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        sortable: true,
        // width: 300,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Versión',
        field: 'version',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estado',
        field: 'estadoDesc',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.formulario.get('id').setValidators(null);
    this.formulario.get('id').updateValueAndValidity();
    this.formulario.get('estado').setValidators(null);
    this.formulario.get('estado').updateValueAndValidity();

    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Versión';
  }

  editar({ rowData }) {
    this.formulario.setValue(rowData);
    this.formulario.get('id').setValidators([Validators.required]);
    this.formulario.get('id').updateValueAndValidity();
    this.formulario.get('estado').setValidators([Validators.required]);
    this.formulario.get('estado').updateValueAndValidity();
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Versiones';
    this.tituloForm = 'Lista De Versiones';
  }

  /** SERVICIOS */
  getVersiones() {
    this.listaVacia = true;
    this.loading = true;

    // this.loading = false;
    // this.listaVacia = false;
    // this.rowData = [
    //   {
    //     "id": 9999,
    //     "anio": 2023,
    //     "nombre": "xxxxx",
    //     "version": "111111",
    //     "estado": "A"
    //   },
    //   {
    //     "id": 8888,
    //     "anio": 2023,
    //     "nombre": "yyyyyyy",
    //     "version": "222222",
    //     "estado": "C"
    //   }
    // ];
    this._versiones.getVersiones().subscribe((res: any[]) => {
      console.log("getVersiones()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;

      for (let index = 0; index < this.rowData.length; index++) {
        this.rowData[index].estadoDesc = (this.rowData[index].estado == "A") ? "ACTIVO" : "CERRADO";
      }
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {

    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._versiones.deleteVersiones(rowData.id),
      })
      .then((res: any) => {
        this.getVersiones();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();

    datos.estado = 'A';
    datos.anio = parseInt(datos.anio)

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._versiones.saveVersiones(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getVersiones();
    }).catch((err) => {
      console.log(err);
      this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar")

    let datos = this.formulario.getRawValue();
    datos.anio = parseInt(datos.anio)

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._versiones.updateVersiones(this.formulario.getRawValue()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getVersiones();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

}
